<template>
  <div>
    <v-card flat style="min-height:150px">
      <p v-if="!isLoading && todos.length === 0" style="margin-top:30px;text-align:center">
        お買い物リストは見つかりませんでした。<br>
        <router-link :to="{name: 'EditTodo'}" class="pink--text">お買い物リストを作成してみましょう！</router-link>
      </p>
      <p style="margin: 0;text-align:right;height:28px;">
        <v-btn
          v-if="!isLoading && todos.length > 0" 
          outlined color="pink" small @click="init()"
        >
          <v-icon>mdi-refresh</v-icon><span style="margin-left:10px">更新</span>
        </v-btn>
      </p>
      <v-list-item two-line
        v-for="todo in todos" :key=todo.id
        style="border-bottom:1px solid #ddd; padding:15px 10px;"
        @click="$router.push({name: 'TodoView', params: {id: todo.id}})"
        tile
      >
        <v-list-item-content>
          <v-list-item-title
          style="font-size:110%;margin-bottom:5px;"
          >{{todo.metas.title}}</v-list-item-title>
          <v-list-item-subtitle>
            <span v-if="todo.metas.author===uid">あなたが作りました</span>
            <span v-else>このリストに参加しています</span>
            <span>（{{todo.count.complete}}／{{todo.count.sum}}完了）</span>
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-icon style="padding-top: 2px;margin-top:0;margin-left:20px;margin-bottom:0;">
          <v-progress-circular
            :rotate="-90"
            :size="60"
            :width="8"
            :value="(todo.count.complete / todo.count.sum)*100"
            color="pink"
          >
            <span v-show="todo.count.complete===todo.count.sum"
              style="font-size:90%"
            >Fin</span>
            <span v-show="todo.count.complete<todo.count.sum"
              style="font-size:90%"
            >
              残{{todo.count.sum - todo.count.complete}}
            </span>
          </v-progress-circular>
        </v-list-item-icon>
      </v-list-item>
      <p v-show="hasMore && !isLoading" style="margin-top: 32px;text-align:center">
        <v-btn color="pink" dark @click="more()">
          もっと見る
        </v-btn>
      </p>
    </v-card>
    <progress-circle v-show="isLoading"></progress-circle>
    <add-list-btn></add-list-btn>
  </div>
</template>

<script>
import AddListBtn from '../components/common/AddListBtn'
import ProgressCircle from '../components/common/ProgressCircle'

// @ is an alias to /src
export default {
  name: 'TodoListView',
  components: {
    AddListBtn,
    ProgressCircle
  },
  data () {
    return {
      isLoading: false
    }
  },
  computed: {
    todos () {
      return this.$store.state.todos.list
    },
    uid () {
      return this.$store.state.user.uid
    },
    hasMore () {
      return this.$store.state.todos.hasMore
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      // 匿名認証
      if (!this.isLogin) await this.$store.dispatch('user/loginAnonymous')

      //データ取得
      this.isLoading = true
      this.$store.commit('todos/init')
      await this.$store.dispatch('todos/getList')
      this.isLoading = false
    },
    async more () {
      //データ取得
      this.isLoading = true
      await this.$store.dispatch('todos/getList')
      this.isLoading = false
    }
  },
  head: {
    meta: [
      {name: 'robots', content: 'noindex'}
    ]
  }
}
</script>
